import { Component, OnInit, ViewChild,ElementRef  } from '@angular/core';
import { DatePipe } from '@angular/common'
import { LeadsService } from '../_service/leads.service';
import { DentalService } from '../_service/dental.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import * as XLSX from 'xlsx';
import { CabService } from '../_service/cab.service';
import { MiscService } from '../_service/misc.service';
declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    todayCount=0;monthCount=0;totalCount=0;allUsers=[];hotLead=0;newLead=0;loading:boolean=false;loaded:boolean=false;cor_ret_loading:boolean=false;
    myrole:string;loadingC:boolean=false;loadingU:boolean=false;circles=[];start_date:string='';end_date:string='';mark_as_affiliate:string;
    loadingI:boolean=true;circleList=[];inactiveUser:string;is_cm_access:string;
    todayAppointmentCount={};completedAppointments={};cancelledAppointments={};ActiveUsers={};currentMonthcount={};
    previousMonthcount={};totalcount={};loadingOPDIPD:boolean=false;usersOdpIpdList=[];circle='';filter='overall';
    totalAppointmentCount={};InsuranceCount={todayCount:0,monthCount:0,totalCount:0};
    OpdFeedBackCount={totalopd:0,activeOpdFeedback:0,followup1_OpdFeedback:0,followup2_OpdFeedback:0,notReceivedOpdFeedback:0,completedOpdFeedback:0};
    admissionloading:boolean=true;admissionloaded:boolean=false;
    todayOpdadmissionloading:boolean=true;
    dischargeloading:boolean=true;dischargeloaded:boolean=false;
    IpdFeedBackCount={totalipd:0,activeIpdFeedback:0,followup1_IpdFeedback:0,followup2_IpdFeedback:0,notReceivedIpdFeedback:0,completedIpdFeedback:0};todayAdmissionList=[];todayDischargeList=[];tomorrowAdmissionList=[];
    loadingdoctorsOPDIPD:boolean=false;DoctorsOdpIpdList=[];DoctorstotalAppointmentCount={};todayOpdAdmissionList=[];inactiveDoctor:string;doctorcircle='';doctorfilter='overall';userswiseTatList=[];insuranceCardTat:any;PaymentsStats = [];Paymentloading:boolean=true;loadingTat:boolean=true;insuranceReport={pending:0, approved:0, rejected:0};insFilter='overall';todayCabReport={booked:0,pending:0,cancelled:0};tomorrowCabReport={booked:0,pending:0,cancelled:0};loadingCabReport:boolean=true;InsuranceCasesBilledAmount=0;InsuranceLastMonthCasesBilledAmount=0;
    hasOpdIpd:string;cm_access:string;treatCategory=[];treatment_catergory:string;treatment_catergory_access:string;total_scan_booked:number=0;total_scan_done:number=0;total_conversation:number=0;dental_loading:boolean=false;full_total_scan_booked:number=0;full_total_scan_done:number=0;full_total_conversation:number=0;TodayCirclewiseIpdCounts=[];TodayCategorywiseIpdCounts=[];TodayCircleCategorywiseIpdCounts=[];
    todayDentalCount=0;monthDentalCount=0;totalDentalCount=0;todayCorporateCount=0;monthCorporateCount=0;totalCorporateCount=0;todayRetailCount=0;monthRetailCount=0;totalRetailCount=0;
    corporate_status_wise_count_arr=[];retail_status_wise_count_arr=[];partner_status_wise_count_arr=[];cor_ret_status_loading:boolean=false;
    loadinghistyoryTat:boolean=false;insuranceHistoryReport=[];
    insFilterRev='today';insuranceHistoryReportTotal=[];todayPartnerLeadCount=0;monthPartnerLeadCount=0;totalPartnerLeadCount=0;
    today_category_ipds=0;today_category_opds=0;today_category_totalDischange=0;total_category_tomorrow_adminsion=0;
    today_ipds= 0;today_opds= 0;todaytotalDischange=0;total_tomorrow_adminsion= 0

    todaytruecoverLeadCount=0;monthtruecoverLeadCount=0;totaltruecoverLeadCount=0;
    todaymedibuddyLeadCount=0;monthmedibuddyLeadCount=0;totalmedibuddyLeadCount=0;
    todayaffinityrefferalLeadCount=0;monthaffinityrefferalLeadCount=0;totalaffinityrefferalLeadCount=0;
    todaysecureNowLeadCount=0;monthsecureNowLeadCount=0;totalsecureNowLeadCount=0;
    cor_ret_partner_loading:boolean=false;cor_partner_status_loading:boolean=false;corporate_lead_partner_status_wise=[];
    total_truecover = 0;total_medibuddy=0; total_affinity_referral = 0;loginUserId:string;user_lead_source='';total_lead_source_data=0;todaypartnerpLeadCount=0;
    monthpartnerpLeadCount=0;totalpartnerpLeadCount=0;total_secure_now=0;todayHealthySureLeadCount=0;monthHealthySureLeadCount=0;totalHealthySureLeadCount=0;total_healthy_sure=0;total_truventiv=0;total_watchfuleye=0;todayTruventivLeadCount=0;monthTruventivLeadCount=0;totalTruventivLeadCount=0;todayWatchfuleyeLeadCount=0;monthWatchfuleyeLeadCount=0;totalWatchfuleyeLeadCount=0;

    CatergoryPaymentsStats = [];CatergoryPaymentloading:boolean=true;

    today_practo_ipds= 0;today_urology_circumcision_ipds=0;today_laproscopy_ipds=0;today_ortho_ipds=0;
    today_vascular_ipds=0;today_kidney_stone_ipds=0;today_cosmetic__ipds=0;today_ent_ipds=0;today_opthomology_ipds=0;
    today_dental_ipds=0;today_general_medicine_ipds=0;today_urology_kideny_ipds=0;today_total_ipds=0;

    totalRevenueBilled_amt=0;totalRevenueGlamyo_share=0;totalRevenueHospital_share=0;totalRevenueDoctor_share=0;totalRevenueActual_revenue=0;revenueloading:boolean=false;

    totalFeedbackIpd=0; activeFeedback=0; completedFeedback=0; followUpOneFeedback=0; followUpTwoFeedback=0; notReceivedFeedback=0;feedback_report_loading:boolean=false;OverAllCategoryWiseRevenue=[];
    constructor(private leadapi:LeadsService,private dentalapi:DentalService,private sharedapi:SharedService,public datepipe: DatePipe, private cabService: CabService,public miscapi:MiscService,private router:Router) { }

    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('dateRangeStart2', {static: false}) dateRangeStart2: ElementRef;
    @ViewChild('dateRangeEnd2', {static: false}) dateRangeEnd2: ElementRef;

    @ViewChild('dateRangeStart3', {static: false}) dateRangeStart3: ElementRef;
    @ViewChild('dateRangeEnd3', {static: false}) dateRangeEnd3: ElementRef;

    @ViewChild('dateRangeStart4', {static: false}) dateRangeStart4: ElementRef;
    @ViewChild('dateRangeEnd4', {static: false}) dateRangeEnd4: ElementRef;

    @ViewChild('dateRangeStart5', {static: false}) dateRangeStart5: ElementRef;
    @ViewChild('dateRangeEnd5', {static: false}) dateRangeEnd5: ElementRef;

    @ViewChild('dateRangeStart6', {static: false}) dateRangeStart6: ElementRef;
    @ViewChild('dateRangeEnd6', {static: false}) dateRangeEnd6: ElementRef;

    @ViewChild('dateRangeStart7', {static: false}) dateRangeStart7: ElementRef;
    @ViewChild('dateRangeEnd7', {static: false}) dateRangeEnd7: ElementRef;

    ngOnInit(): void
    {
        // this.start_date = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        // this.end_date = this.datepipe.transform(new Date(), 'MM/dd/yyyy');

        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.sharedapi.getCMAccess()
        .subscribe((item:string) => {this.cm_access=item;});
        this.sharedapi.getUserId()
        .subscribe((item:string) => {this.loginUserId=item;});
        this.sharedapi.getLeadSourceOfUser()
        .subscribe((item:string) => {this.user_lead_source=item;});
        
        

        this.myrole = localStorage.getItem('role');
        this.cm_access = localStorage.getItem('CMAccess');
        this.loginUserId = localStorage.getItem('loginuserId');
        this.user_lead_source = localStorage.getItem('userLeadSource');

        this.treatment_catergory_access = localStorage.getItem('treatment_catergory_access');
        this.mark_as_affiliate = localStorage.getItem('mark_as_affiliate');
        if(this.myrole=='12'){
            this.router.navigateByUrl('/leads');
        }

        if(this.myrole=='1' || (this.myrole == '3' && this.cm_access == '1')){
            this.getPaymentsStats();
            this.getPaymentStatCatWise();

        }
        if(this.myrole=='7'){
            this.router.navigateByUrl('/opds');
            this.is_cm_access = 'true';
        }
        if(this.myrole!='19')
        this.getcircle();
        if(this.myrole!='6' && this.myrole!='19' && this.myrole!='20' && this.myrole!='21')
        this.getTodaysIpdList();

        if(this.myrole!='19' && this.myrole!='20' && this.myrole!='21')
        this.getTodayAdmissionDischarge();
        if(this.myrole=='1' || this.treatment_catergory_access == '4')
        {
            this.getDentalAppointmentData();
            this.getTotalDentalAppointmentData();
            this.getdashboadDentalData();
        }
        
        if(this.myrole=='1' || this.myrole=='5'){
            this.getInsuranceReportofPreAuthApprovalFinal();
        }

        if(this.myrole=='5') {
            this.getInsuranceCount();
            this.getInsuranceReport();
        } else if(this.myrole=='4' && this.cm_access=='1')
        {
            this.getdashboadAllData();
            //this.getDashboardUserOpdIpdCount();
        }
        else if(this.myrole=='6')
        {
            this.getdashboadData();
            //this.getCircleData();
            //this.getDashboardUserOpdIpdCount();
            this.getdashboadAllData();
        }
        else if(this.myrole=='8'){
          this.getCabReport();
          //this.getDashboardUserOpdIpdCount();
        }
        else if(this.myrole=='9' || this.myrole=='10'){

        }
        else if(this.myrole!='13' && this.myrole!='19'){
            //this.getCircleData();
            this.getdashboadData();
            //this.getUsersLeadCount();
            this.getdashboadAllData();
            //this.getDashboardUserOpdIpdCount();
            //this.getDashboardDoctorsOpdIpdCount();
            this.getInsuranceCardTat();
            this.getTreatmentCategory();
            this.getCirclewiseIpdCounts();
            
        }
        else if(this.myrole=='13'){
            this.getdashboadAllData();
            this.getdashboadData();
        }

        if(this.myrole=='1' || this.myrole=='14'){
           // this.getCorporateRetailLeadsCount();
        }
        if(this.myrole=='14' || this.myrole=='16')
        {
            //this.getCorporateRetailLeadsCountStatusWise();
            //this.getCorporateRetailCountPartnerWise();
            //this.getCorporatePartnerStatusWise();
        }

        if(this.myrole=='16'){
            //this.getCorporatePartnerStatusWiseLeadSource();
            //this.getCorporateRetailCountPartnerWiseLeadSource();
        }

        if(this.myrole=='1' || this.myrole=='18'){
            this.getCategorywiseIpdCounts();
           // this.getCorporatePartnerStatusWise();
            
        }
        if(this.myrole=='1' || this.myrole=='8' || this.myrole=='18'){
            this.getCircleCategorywiseIpdCounts();
        }
        if(this.myrole=='1'){
            this.getFeedBackReportCount();
            this.getOverAllRevenueCategorywise();
        }
        
    }

    async getCorporateRetailLeadsCount()
    {
        this.cor_ret_loading=true;
        await this.leadapi.getCorporateRetailLeadsCount().subscribe((data:any) => {
            this.cor_ret_loading=false;
            if(data.status)
            {
                this.todayCorporateCount=data.today_corporate;
                this.monthCorporateCount=data.this_month_corporate;
                this.totalCorporateCount=data.total_corporate;
                this.todayRetailCount=data.today_retail;
                this.monthRetailCount=data.this_month_retail;
                this.totalRetailCount=data.total_retail;
                this.todayPartnerLeadCount=data.today_partner;
                this.monthPartnerLeadCount=data.this_month_partner;
                this.totalPartnerLeadCount=data.total_partner;
            }else{
                this.todayCorporateCount=0;
                this.monthCorporateCount=0;
                this.totalCorporateCount=0;
                this.todayRetailCount=0;
                this.monthRetailCount=0;
                this.totalRetailCount=0;
                this.todayPartnerLeadCount=0;
                this.monthPartnerLeadCount=0;
                this.totalPartnerLeadCount=0;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCorporateRetailLeadsCountStatusWise()
    {
        this.cor_ret_status_loading=true;
        await this.leadapi.getCorporateRetailLeadsCountStatusWise().subscribe((data:any) => {
            this.cor_ret_status_loading=false;
            if(data.status)
            {
                this.corporate_status_wise_count_arr=data.corporate_count_status_wise;
                this.retail_status_wise_count_arr=data.retail_count_status_wise;
                this.partner_status_wise_count_arr=data.partner_count_status_wise;
            }else{
                this.corporate_status_wise_count_arr=[];
                this.retail_status_wise_count_arr=[];
                this.partner_status_wise_count_arr=[];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCorporateRetailCountPartnerWise()
    {
        this.cor_ret_partner_loading=true;
        await this.leadapi.getCorporateRetailCountPartnerWise().subscribe((data:any) => {
            this.cor_ret_partner_loading=false;
            if(data.status)
            {
                this.todaytruecoverLeadCount=data.today_tc_partner;
                this.monthtruecoverLeadCount=data.this_month_tc_partner;
                this.totaltruecoverLeadCount=data.total_tc_partner;
                this.todaymedibuddyLeadCount=data.today_md_partner;
                this.monthmedibuddyLeadCount=data.this_month_md_partner;
                this.totalmedibuddyLeadCount=data.total_md_partner;
                this.todayaffinityrefferalLeadCount=data.today_ar_partner;
                this.monthaffinityrefferalLeadCount=data.this_month_ar_partner;
                this.totalaffinityrefferalLeadCount=data.total_ar_partner;
                this.todaysecureNowLeadCount=data.today_sn_partner;
                this.monthsecureNowLeadCount=data.this_month_sn_partner;
                this.totalsecureNowLeadCount=data.total_sn_partner;
                this.todayHealthySureLeadCount=data.today_hs_partner;
                this.monthHealthySureLeadCount=data.this_month_hs_partner;
                this.totalHealthySureLeadCount=data.total_hs_partner;
                this.todayTruventivLeadCount=data.today_tr_partner;
                this.monthTruventivLeadCount=data.this_month_tr_partner;
                this.totalTruventivLeadCount=data.total_tr_partner;
                this.todayWatchfuleyeLeadCount=data.today_wf_partner;
                this.monthWatchfuleyeLeadCount=data.this_month_wf_partner;
                this.totalWatchfuleyeLeadCount=data.total_wf_partner;

            }else{
                this.todaytruecoverLeadCount=0;
                this.monthtruecoverLeadCount=0;
                this.totaltruecoverLeadCount=0;
                this.todaymedibuddyLeadCount=0;
                this.monthmedibuddyLeadCount=0;
                this.totalmedibuddyLeadCount=0;
                this.todayaffinityrefferalLeadCount=0;
                this.monthaffinityrefferalLeadCount=0;
                this.totalaffinityrefferalLeadCount=0;
                this.todaysecureNowLeadCount=0;
                this.monthsecureNowLeadCount=0;
                this.totalsecureNowLeadCount=0;
                this.todayHealthySureLeadCount=0;
                this.monthHealthySureLeadCount=0;
                this.totalHealthySureLeadCount=0;
                this.todayTruventivLeadCount=0;
                this.monthTruventivLeadCount=0;
                this.totalTruventivLeadCount=0;
                this.todayWatchfuleyeLeadCount=0;
                this.monthWatchfuleyeLeadCount=0;
                this.totalWatchfuleyeLeadCount=0;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCorporateRetailCountPartnerWiseLeadSource()
    {
        this.cor_ret_partner_loading=true;
        await this.leadapi.getCorporateRetailCountPartnerWiseLeadSource().subscribe((data:any) => {
            this.cor_ret_partner_loading=false;
            if(data.status)
            {
                this.todaypartnerpLeadCount=data.today_tc_partner;
                this.monthpartnerpLeadCount=data.this_month_tc_partner;
                this.totalpartnerpLeadCount=data.total_tc_partner;
            }else{
                this.todaypartnerpLeadCount=0;
                this.monthpartnerpLeadCount=0;
                this.totalpartnerpLeadCount=0;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    

    async getCorporatePartnerStatusWise()
    {
        this.cor_partner_status_loading=true;
        await this.leadapi.getCorporatePartnerStatusWise().subscribe((data:any) => {
            this.cor_partner_status_loading=false;
            if(data.status)
            {
                this.corporate_lead_partner_status_wise = data.status_wise_partner;
                this.total_truecover = data.total_total_truecover;
                this.total_medibuddy = data.total_total_medibuddy;
                this.total_affinity_referral = data.total_total_affinity_referral;
                this.total_secure_now = data.total_total_secure_now;
                this.total_healthy_sure = data.total_total_healthy_sure;
                this.total_truventiv = data.total_total_truventiv;
                this.total_watchfuleye = data.total_total_watchfuleye;
                
            }else{
                this.corporate_lead_partner_status_wise=[];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCorporatePartnerStatusWiseLeadSource()
    {
        this.cor_partner_status_loading=true;
        await this.leadapi.getCorporatePartnerStatusWiseLeadSource().subscribe((data:any) => {
            this.cor_partner_status_loading=false;
            if(data.status)
            {
                this.corporate_lead_partner_status_wise = data.status_wise_partner;
                this.total_lead_source_data = data.total_total_lead_source;
            }else{
                this.corporate_lead_partner_status_wise=[];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCirclewiseIpdCounts()
    {
        await this.leadapi.getCirclewiseIpdCounts().subscribe((data:any) => {
            if(data.status)
            {
                this.TodayCirclewiseIpdCounts = data.todayData;
                
                this.today_ipds = data.today_ipds;
                this.today_opds = data.today_opds;
                this.todaytotalDischange = data.todaytotalDischange;
                this.total_tomorrow_adminsion = data.total_tomorrow_adminsion;

            }else{
                this.TodayCirclewiseIpdCounts = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    // deepak
    async getCircleCategorywiseIpdCounts()
    {
        await this.leadapi.getCircleCategorywiseIpdCounts().subscribe((data:any) => {
            if(data.status)
            {
                this.TodayCircleCategorywiseIpdCounts = data.todayData;
                
                this.today_practo_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.practo).reduce((prev, curr) => prev + curr, 0);
                this.today_urology_circumcision_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.urology_circumcision).reduce((prev, curr) => prev + curr, 0);
                this.today_laproscopy_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.laproscopy).reduce((prev, curr) => prev + curr, 0);
                this.today_ortho_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.ortho).reduce((prev, curr) => prev + curr, 0);
                this.today_vascular_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.vascular).reduce((prev, curr) => prev + curr, 0);
                this.today_kidney_stone_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.kidney_stone).reduce((prev, curr) => prev + curr, 0);
                this.today_cosmetic__ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.cosmetic).reduce((prev, curr) => prev + curr, 0);
                this.today_ent_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.ent).reduce((prev, curr) => prev + curr, 0);
                this.today_opthomology_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.opthomology).reduce((prev, curr) => prev + curr, 0);
                this.today_dental_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.dental).reduce((prev, curr) => prev + curr, 0);
                this.today_general_medicine_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.general_medicine).reduce((prev, curr) => prev + curr, 0);
                this.today_urology_kideny_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.urology_kideny).reduce((prev, curr) => prev + curr, 0);
                this.today_total_ipds = this.TodayCircleCategorywiseIpdCounts.map(item => item.grand_total).reduce((prev, curr) => prev + curr, 0);

            }else{
                this.TodayCircleCategorywiseIpdCounts = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    // end

    async getCategorywiseIpdCounts()
    {
        await this.leadapi.getCategorywiseIpdCounts().subscribe((data:any) => {
            if(data.status)
            {
                this.TodayCategorywiseIpdCounts = data.todayData;
                //console.log(this.TodayCategorywiseIpdCounts);
                this.today_category_ipds = data.today_ipds;
                this.today_category_opds = data.today_opds;
                this.today_category_totalDischange = data.todaytotalDischange;
                this.total_category_tomorrow_adminsion = data.total_tomorrow_adminsion;

            }else{
                this.TodayCategorywiseIpdCounts = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getPaymentsStats(){
        let qString = 'date_range='+this.start_date+'-'+this.end_date+'&treatment_catergory='+this.treatment_catergory;
        this.leadapi.getPaymentStat(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.PaymentsStats = data.result;
                this.Paymentloading=false;
            }
        }, error => {
            this.Paymentloading=true;
            this.sharedapi.checkError(error);
        });
    }

    getPaymentStatCatWise(){
        let qString = 'date_range='+this.start_date+'-'+this.end_date+'&treatment_catergory='+this.treatment_catergory;
        this.leadapi.getPaymentStatCatWise(qString).subscribe((data:any) => {
            //console.log(data);
            if(data.status)
            {
                this.CatergoryPaymentsStats = data.result;
                this.CatergoryPaymentloading=false;
            }
        }, error => {
             this.CatergoryPaymentloading=true;
            this.sharedapi.checkError(error);
        });
    }

    getInsuranceCardData()
    {


        this.leadapi.getInsuranceCardData().subscribe((data:any) => {
            if(data.status)
            {


            }
        }, error => {

            this.sharedapi.checkError(error);
        });
    }

    async getTodayAdmissionDischarge()
    {
        this.admissionloading = true;
        this.admissionloaded = false;
        this.dischargeloading = true;
        this.dischargeloaded = false;
        this.leadapi.getTodayAdmissiondischarge().subscribe((data:any) => {
            if(data.status)
            {
                this.todayAdmissionList= data.todayData.ipdAdmission;
                this.todayDischargeList= data.todayData.ipdDischarge;
                this.tomorrowAdmissionList = data.tomorrowIpdAdmissions;
                this.admissionloading = false;
                this.admissionloaded = true;
                this.dischargeloading = false;
                this.dischargeloaded = true;
            }
        }, error => {
            this.admissionloading = false;
            this.admissionloaded = true;
            this.dischargeloading = false;
            this.dischargeloaded = true;
            this.sharedapi.checkError(error);
        });
    }

    async getTodaysIpdList()
    {
        this.todayOpdadmissionloading = true;

        this.leadapi.getTodayIpdList().subscribe((data:any) => {
            if(data.status)
            {
                this.todayOpdAdmissionList= data.todayOpdData;
                this.todayOpdadmissionloading = false;

            }
        }, error => {
            this.todayOpdadmissionloading = false;
            this.sharedapi.checkError(error);
        });
    }

    getRoomCategory(room)
    {
        return this.sharedapi.getRoomCategory(room);
    }
    getPaymentType(payment_type)
    {
        return this.sharedapi.getPaymentType(payment_type);
    }

    async getDashboardUserOpdIpdCount()
    {
        if(this.myrole=='1' || this.myrole=='3' || this.myrole=='4' || this.myrole=='7' || this.myrole=='6' || this.myrole=='8' || this.myrole=='18')
        {
            this.usersOdpIpdList=[];
            this.loadingOPDIPD = true;
            if(this.filter!='overall')
            {
                this.start_date = '';this.end_date = '';
            }
            let qString = 'date_range='+this.start_date+'-'+this.end_date+'&inactiveUser='+this.inactiveUser+'&circle='+this.circle+'&filter='+this.filter+'&is_cm_access='+this.is_cm_access+'&has_opd_ipd='+this.hasOpdIpd;
            this.leadapi.getDashboardUserOpd_Ipd(qString).subscribe((data:any) => {
                this.loadingOPDIPD = false;
                if(data.status)
                {
                    this.usersOdpIpdList = data.result;
                    this.totalAppointmentCount = data.total;
                    this.userswiseTatList = data.tat;
                }else{
                    this.usersOdpIpdList=[];
                }
            }, error => {
                this.loadingOPDIPD = false;
                this.sharedapi.checkError(error);
            });
        }
    }

    exportAppointmentReport()
    {
        if(this.myrole=='1' || this.myrole=='4')
        {
            if(this.usersOdpIpdList.length>0)
            {
                let data = [];
                let titles = ['BD Name','Lead Count','IPD Count','Active IPD Count','OPD Count','Active OPD Count','Scan Booked','Scan Done'];

                data.push(titles);
                for(let key in this.usersOdpIpdList)
                {

                    let ipdcount = this.usersOdpIpdList[key].activeIpdcount + this.usersOdpIpdList[key].completedIpdcount;

                    let activeIpd = this.usersOdpIpdList[key].activeIpdcount;

                    let opdcount = this.usersOdpIpdList[key].activeOpdcount + this.usersOdpIpdList[key].completedOpdcount;

                    let activeopd = this.usersOdpIpdList[key].activeOpdcount;

                    let exdata = [this.usersOdpIpdList[key].name,this.usersOdpIpdList[key].leadCount,ipdcount,activeIpd,opdcount,activeopd,this.usersOdpIpdList[key].scanBooked,this.usersOdpIpdList[key].scanDone];

                    data.push(exdata);
                }


                let ws = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            /* save to file */
            let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
            XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
            }else{
                this.sharedapi.presentToast('Something went wrong, Try Again!');
            }
        }else{
            this.sharedapi.presentToast('Access Denied!');
        }
    }

    async getDashboardDoctorsOpdIpdCount()
    {
        if(this.myrole=='1' || this.myrole=='7' || this.myrole=='3' || this.myrole=='4')
        {
            this.DoctorsOdpIpdList=[];
            this.loadingdoctorsOPDIPD = true;
            if(this.filter!='overall')
            {
                this.start_date = '';this.end_date = '';
            }
            let qString = 'date_range='+this.start_date+'-'+this.end_date+'&inactiveUser='+this.inactiveDoctor+'&circle='+this.doctorcircle+'&filter='+this.doctorfilter;
            this.leadapi.getDashboardDoctorsOpd_Ipd(qString).subscribe((data:any) => {
                this.loadingdoctorsOPDIPD = false;
                if(data.status)
                {
                   this.DoctorsOdpIpdList = data.result;
                   this.DoctorstotalAppointmentCount = data.total;
                }else{
                   this.DoctorsOdpIpdList=[];
                }
            }, error => {
                this.loadingdoctorsOPDIPD = false;
                this.sharedapi.checkError(error);
            });
        }
    }

    async getdashboadAllData()
    {

        let qString = 'circle='+this.circle;
        this.leadapi.getDashboardAllCount(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.todayAppointmentCount= data.todayAppointmentCount
                if(this.myrole=='13'){
                    this.completedAppointments = data.completedAppointments;
                    this.cancelledAppointments = data.cancelledAppointments;
                }
                if(this.myrole=='1' || this.myrole=='3' || this.myrole=='7'  || this.myrole=='15')
                {
                 this.completedAppointments = data.completedAppointments;
                 this.cancelledAppointments = data.cancelledAppointments;
                 this.ActiveUsers = data.total_ActiveUsers;
                }else if(this.myrole=='4'){
                    this.OpdFeedBackCount= data.OpdFeebackData;
                    this.IpdFeedBackCount= data.IpdFeebackData;
                }{
                   this.currentMonthcount = data.currentMonthAppointment;
                   this.previousMonthcount = data.previousMonthAppointment;
                   this.totalcount = data.Total_Count_data;
                }

            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getPendingFeedBack(data,type)
    {
        let pendingCount=0;
        if(type=='1'){
            return pendingCount= parseInt(data.totalopd) - (parseInt(data.activeOpdFeedback) + parseInt(data.followup1_OpdFeedback) + parseInt(data.followup2_OpdFeedback) + parseInt(data.notReceivedOpdFeedback) + parseInt(data.completedOpdFeedback));
        }else{
            return pendingCount= parseInt(data.totalipd) - (parseInt(data.activeIpdFeedback) + parseInt(data.followup1_IpdFeedback) + parseInt(data.followup2_IpdFeedback) + parseInt(data.notReceivedIpdFeedback) + parseInt(data.completedIpdFeedback));
        }

    }


    async getdashboadData()
    {
        this.loading = true;
        this.leadapi.getDashboardCount().subscribe((data:any) => {
            this.loading = false;
            if(data.status)
            {
                this.todayCount = data.todayCount;
                this.monthCount = data.monthCount;
                this.totalCount = data.totalCount;
                this.hotLead = data.hotLeads;
                this.newLead = data.newLeads;
            }
        }, error => {
            this.loading = false;
            this.sharedapi.checkError(error);
        });
    }

    async getdashboadDentalData()
    {
        this.dental_loading = true;
        this.leadapi.getDashboardDentalCount().subscribe((data:any) => {
            this.dental_loading = false;
            if(data.status)
            {
                this.todayDentalCount = data.todayDentalCount;
                this.monthDentalCount = data.monthDentalCount;
                this.totalDentalCount = data.totalDentalCount;
            }
        }, error => {
            this.dental_loading = false;
            this.sharedapi.checkError(error);
        });
    }

    async getCircleData()
    {
        if(this.myrole=='1' || this.myrole=='6' || this.myrole=='7' || this.myrole=='18')
        {
            this.circles = [];
            let qString = 'date_range='+this.start_date+'-'+this.end_date;
            this.loadingC = true;
            this.leadapi.getCircleCount(qString).subscribe((data:any) => {
                this.loadingC = false;
                if(data.status)
                {
                    this.circles = data.data;
                }
            }, error => {
                this.loadingC = false;
                this.sharedapi.checkError(error);
            });
        }
    }

    async getUsersLeadCount()
    {
        if(this.myrole=='1' || this.myrole=='3' || this.myrole=='7'  || this.myrole=='18')
        {
            this.allUsers = [];this.loaded = false;
            let qString = 'date_range='+this.start_date+'-'+this.end_date;
            this.loadingU = true;
            this.leadapi.getUsersLeadCount(qString).subscribe((data:any) => {
                this.loaded = true;
                this.loadingU = false;
                if(data.status)
                {
                    this.allUsers = data.data;
                }
            }, error => {
                this.loadingU = false;
                this.sharedapi.checkError(error);
            });
        }
    }


    clearDate(type)
    {
        this.start_date = '';
        this.end_date = '';

        if(type==1){
            this.dateRangeStart.nativeElement.value = "";
            this.dateRangeEnd.nativeElement.value = "";
            //this.getCircleData();
            //this.getUsersLeadCount();
            //this.getDashboardUserOpdIpdCount()
        }else if(type==2){
            this.dateRangeStart2.nativeElement.value = "";
            this.dateRangeEnd2.nativeElement.value = "";
            //this.getCircleData();
            //this.getDashboardDoctorsOpdIpdCount()
        }else if(type==4){
          this.dateRangeStart4.nativeElement.value = "";
            this.dateRangeEnd4.nativeElement.value = "";
          this.getInsuranceCardTat();
        }else if(type==5){
            this.dateRangeStart5.nativeElement.value = "";
              this.dateRangeEnd5.nativeElement.value = "";
            this.getInsuranceReportofPreAuthApprovalFinal();
        }else if(type==6){
            this.dateRangeStart6.nativeElement.value = "";
              this.dateRangeEnd6.nativeElement.value = "";
            this.getPaymentStatCatWise();
        }else if(type==7){
            this.dateRangeStart7.nativeElement.value = "";
              this.dateRangeEnd7.nativeElement.value = "";
            this.getOverAllRevenueCategorywise();
        }

        else{
            this.dateRangeStart3.nativeElement.value = "";
            this.dateRangeEnd3.nativeElement.value = "";
            this.getPaymentsStats();
        }

    }

    dateRangeChange(date1,date2,type)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            if(type==1){
                //this.getCircleData();
                //this.getUsersLeadCount();
                //this.getDashboardUserOpdIpdCount();
            }else if(type==2){
                //this.getCircleData();
                //this.getDashboardDoctorsOpdIpdCount();
            }else if(type==4){
              this.getInsuranceCardTat();
            }else if(type==5){
                this.getInsuranceReportofPreAuthApprovalFinal();
            }else if(type==6){
                this.getPaymentStatCatWise();
            }else if(type==7){
                this.getOverAllRevenueCategorywise();
            }
            else{
                this.getPaymentsStats();
            }

        }
    }

    getPercentage(findingValue,totalValue)
    {
        return totalValue*100/findingValue;
    }

    //for insurance user
    getInsuranceCount()
    {
        this.loadingI = true;
        this.leadapi.getInsuranceCount().subscribe((data:any) => {
            this.loadingI = false;
            if(data.status)
            {
                this.InsuranceCount = data.total;
                this.InsuranceCasesBilledAmount = data.InsuranceCasesBilledAmount;
                this.InsuranceLastMonthCasesBilledAmount = data.InsuranceLastMonthCasesBilledAmount
            }
        }, error => {
            this.loadingI = false;
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circleList = data.data;
            }else{
                this.circleList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getInsuranceCardTat()
    {
      if(this.insFilter!='overall')
      {
          this.start_date = '';this.end_date = '';
      }
      let qString = 'date_range='+this.start_date+'-'+this.end_date+'&filter='+this.insFilter;
      this.leadapi.getInsuranceCardTatList(qString).subscribe((data:any) => {
          if(data.status) {
              this.insuranceCardTat = data.data;
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
    }

    getInsuranceReport()
    {
      this.loadingTat = true;
      this.leadapi.getInsuranceCardReport().subscribe((data:any) => {
          this.loadingTat = false;
          if(data.status) {
              this.insuranceReport = data.data;
          }
      }, error => {
          this.loadingTat = false;
          this.sharedapi.checkError(error);
      });
    }

    getInsuranceReportofPreAuthApprovalFinal()
    {
        this.insuranceHistoryReport=[];
        this.insuranceHistoryReportTotal=[];
        this.loadinghistyoryTat = true;
        if(this.insFilterRev!='overall')
        {
            this.start_date = '';this.end_date = '';
        }
        let qString = 'date_range='+this.start_date+'-'+this.end_date+'&filter='+this.insFilterRev;
        this.leadapi.getInsuranceCardHistoryReport(qString).subscribe((data:any) => {
            this.loadinghistyoryTat = false;
            if(data.status) {
                this.insuranceHistoryReport = data.data;
                this.insuranceHistoryReportTotal = data.final_total_data;
            }
        }, error => {
            this.loadinghistyoryTat = false;
            this.sharedapi.checkError(error);
        });
    }

    getCabReport()
    {
        this.loadingCabReport = true;
        this.cabService.getCabReport().subscribe((data:any) => {
          this.loadingCabReport = false;
          if(data.status) {
              this.todayCabReport = data.data.todayCab;
              this.tomorrowCabReport = data.data.tomorrowCab;
          }
      }, error => {
          this.loadingCabReport = false;
          this.sharedapi.checkError(error);
      });
    }

    getTreatmentCategoryReport()
    {
      // this.loadingCabReport = true;
      this.leadapi.getTreatmentCategoryReport().subscribe((data:any) => {
          // this.loadingCabReport = false;
          if(data.status) {
              //console.log(data);
          }
      }, error => {
          this.loadingCabReport = false;
          this.sharedapi.checkError(error);
      });
    }

    getTotalDentalAppointmentData() {
        this.dental_loading = true;
        this.dentalapi.getTotalDentalAppointmentDataForDashboard().subscribe((data:any) => {
            this.dental_loading = false;
            if(data.status) {
                this.full_total_scan_booked = data.full_total_scan_booked;
                this.full_total_scan_done = data.full_total_scan_done;
                this.full_total_conversation = data.full_total_conversation;
            }
        }, error => {
            this.dental_loading = false;
            this.sharedapi.checkError(error);
        });
    }

    getDentalAppointmentData() {
        this.dental_loading = true;
        this.dentalapi.getDentalAppointmentDataForDashboard().subscribe((data:any) => {
            this.dental_loading = false;
            if(data.status) {
                this.total_scan_booked = data.total_scan_booked;
                this.total_scan_done = data.total_scan_done;
                this.total_conversation = data.total_conversation;
            }
        }, error => {
            this.dental_loading = false;
            this.sharedapi.checkError(error);
        });
    }

    async getFeedBackReportCount()
    {
        await this.leadapi.getFeedBackReportCount().subscribe((data:any) => {
            if(data.status)
            {
                this.OpdFeedBackCount= data.OpdFeebackData;
                this.IpdFeedBackCount= data.IpdFeebackData;
            }else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getOverAllRevenueCategorywise()
    {
        this.revenueloading = true;
        let qString = 'date_range='+this.start_date+'-'+this.end_date;
        await this.leadapi.getOverAllRevenueCategorywise(qString).subscribe((data:any) => {
            this.revenueloading = false;
            if(data.status)
            {
                this.OverAllCategoryWiseRevenue = data.todayData;
                this.totalRevenueBilled_amt = data.totalRevenueBilled_amt;
                this.totalRevenueGlamyo_share = data.totalRevenueGlamyo_share;
                this.totalRevenueHospital_share = data.totalRevenueHospital_share;
                this.totalRevenueDoctor_share = data.totalRevenueDoctor_share;
                this.totalRevenueActual_revenue = data.totalRevenueActual_revenue;
            }else{
                this.OverAllCategoryWiseRevenue = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
}
